/* Wondr Light - shared behaviour: header, reveal on scroll, lazy background video. Vanilla JS. */
(function () {
  'use strict';

  if (window.__wonderBase) return;
  window.__wonderBase = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------------- Header ---------------- */

  var ticking = false;

  function updateHeader() {
    ticking = false;
    var header = document.querySelector('[data-wonder-header]');
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 24);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateHeader);
  }

  function setMenu(open) {
    var header = document.querySelector('[data-wonder-header]');
    if (!header) return;
    var toggle = header.querySelector('[data-wonder-menu-toggle]');
    var panel = header.querySelector('[data-wonder-menu-panel]');
    if (!toggle || !panel) return;

    header.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', toggle.getAttribute(open ? 'data-label-close' : 'data-label-open'));
    if (open) {
      panel.removeAttribute('inert');
    } else {
      panel.setAttribute('inert', '');
    }
  }

  /* ---------------- Reveal on scroll ---------------- */

  var revealObserver = null;

  function initReveal(scope) {
    var items = (scope || document).querySelectorAll('[data-wonder-reveal]:not(.is-visible)');
    if (!items.length) return;

    if (!('IntersectionObserver' in window) || reduceMotion.matches) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    revealObserver =
      revealObserver ||
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );

    items.forEach(function (item) {
      revealObserver.observe(item);
    });
  }

  /* ---------------- Background video ---------------- */

  var videoObserver = null;

  function isRendered(element) {
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  function playVideo(video) {
    if (reduceMotion.matches || video.getAttribute('data-wonder-user-paused') === 'true') return;
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') promise.catch(function () {});
  }

  function prepareVideo(video) {
    if (video.getAttribute('data-wonder-ready') === 'true') return;
    if (reduceMotion.matches || !isRendered(video)) return;

    video.setAttribute('data-wonder-ready', 'true');
    video.addEventListener('playing', function () {
      video.classList.add('is-playing');
      var section = video.closest('[data-wonder-hero]');
      var button = section && section.querySelector('[data-wonder-video-toggle]');
      if (button) button.hidden = false;
    });

    video.src = video.getAttribute('data-src');
    video.load();

    if (!('IntersectionObserver' in window)) {
      playVideo(video);
      return;
    }

    videoObserver =
      videoObserver ||
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              playVideo(entry.target);
            } else {
              entry.target.pause();
            }
          });
        },
        { threshold: 0.1 }
      );
    videoObserver.observe(video);
  }

  function toggleSectionVideo(button) {
    var section = button.closest('[data-wonder-hero]') || document;
    var pause = button.getAttribute('data-paused') !== 'true';

    button.setAttribute('data-paused', pause ? 'true' : 'false');
    button.setAttribute('aria-label', button.getAttribute(pause ? 'data-label-play' : 'data-label-pause'));

    section.querySelectorAll('[data-wonder-video][data-wonder-ready="true"]').forEach(function (video) {
      if (pause) {
        video.setAttribute('data-wonder-user-paused', 'true');
        video.pause();
      } else {
        video.removeAttribute('data-wonder-user-paused');
        playVideo(video);
      }
    });
  }

  /* ---------------- Wiring ---------------- */

  function init(scope) {
    initReveal(scope);
    (scope || document).querySelectorAll('[data-wonder-video]').forEach(prepareVideo);
  }

  document.addEventListener('click', function (event) {
    var menuToggle = event.target.closest('[data-wonder-menu-toggle]');
    if (menuToggle) {
      setMenu(menuToggle.getAttribute('aria-expanded') !== 'true');
      return;
    }

    if (event.target.closest('[data-wonder-menu-panel] a')) {
      setMenu(false);
      return;
    }

    var scrollButton = event.target.closest('[data-wonder-scroll-next]');
    if (scrollButton) {
      var current = scrollButton.closest('.shopify-section');
      var next = current && current.nextElementSibling;
      if (next) next.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      return;
    }

    var videoButton = event.target.closest('[data-wonder-video-toggle]');
    if (videoButton) toggleSectionVideo(videoButton);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var header = document.querySelector('[data-wonder-header].is-open');
    if (!header) return;
    var toggle = header.querySelector('[data-wonder-menu-toggle]');
    setMenu(false);
    if (toggle) toggle.focus();
  });

  var desktop = window.matchMedia('(min-width: 750px)');
  var onBreakpoint = function (event) {
    if (event.matches) setMenu(false);
  };
  if (desktop.addEventListener) {
    desktop.addEventListener('change', onBreakpoint);
  } else if (desktop.addListener) {
    desktop.addListener(onBreakpoint);
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  var resizeTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      document.querySelectorAll('[data-wonder-video]').forEach(prepareVideo);
    }, 200);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    updateHeader();
  });

  updateHeader();
  init(document);
})();